import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { NetworkLossSettingsState } from "Interfaces";

const initialState: NetworkLossSettingsState = {
	detectedObject: "Ethernet",
	ignoringInterval: 0,
	hostIpAddress: "192.158.1.38",
	pingInterval: 5,
	alarmOut: false,
	snapshot: false,
	recording: false,
	email: false,
	ftp: false
};

const setNetworkLossEventReducer = (
	state: NetworkLossSettingsState,
	action: PayloadAction<NetworkLossSettingsState>
) => {
	return action.payload;
};

const getNetworkLossEvent = (state: NetworkLossSettingsState) => {
	return state;
};

const networkLossEventSlice = createAppSlice({
	initialState,
	name: "networkLossEvent",
	reducers: {
		setNetworkLossEventAction: setNetworkLossEventReducer
	},
	selectors: {
		selectNetworkLossEvent: getNetworkLossEvent
	}
});

export default networkLossEventSlice;

export const { setNetworkLossEventAction } = networkLossEventSlice.actions;
export const { selectNetworkLossEvent } = networkLossEventSlice.selectors;
